import React, {useState, useEffect} from "react";
import './index.css';
import Barra from "../../components/barrasuperior"
import imagenarriba from '../../assets/imgportada.png';
import BooksSlider from "../../components/booksSlider";
import Footer from "../../components/homecomponentes/footer";
import ToggleSwitch from "../../components/categoriaToggle/categoriatoggle";
import { obtenerFondos } from "../../services/FondoService";

function EstudianteMain (){
    const [category1, setCategory1] = useState(true);
    const [fondos, setFondos] = useState([]);

    useEffect(() => {
        // Cargar los fondos cuando el componente se monta
        const cargarFondos = async () => {
            const fondosData = await obtenerFondos();
            setFondos(fondosData);
        };
        cargarFondos();
    }, []);


    return(
        <div>
            <div className="principal-div">
                <Barra />
                <div className="homePage-container-limit">
                    <div className="homePage-container">
                        <div className="principal-bienvenidaposter">
                            <div className="principal-posterLeft">
                                <span>¡Libros que inspiran, enseñan y transforman!</span>
                                <span>Descubre lo que nuestra biblioteca tiene para ti</span>
                                <span>Contamos con libros de todas las categorías que te imagines como: Medicina,
                                    Adolescente, Ingeniería, Thriller, Derecho, Ficción, Marketing, Poesía, Arquitectura, etc. Y tienes acceso 
                                    a todos ellos con solo ser miembro de la UAM.
                                </span>
                            </div>
                            <div className="principal-posterRight">
                                <img src={imagenarriba} alt="Imagen de Bienvenida" />
                            </div>
                        </div>
                        <ToggleSwitch isAcademic={category1} setIsAcademic={setCategory1} />
                        <div className="principal-sliders">
                            {fondos.map((fondo) => (
                                <BooksSlider
                                    key={fondo.idFondo}
                                    idFondo={fondo.idFondo}
                                    nombreFondo={fondo.nombreFondo}
                                    isAcademic={category1}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '8rem' }}>
                <Footer />
            </div>
        </div>
    )

}

export default EstudianteMain;